import type { JiraProjectsHelpCenterMappingStatus } from './__generated__/manageProjects_GetProjectsQuery.graphql';

export enum ProjectsMappingStatus {
	UNLINKED = 'UNLINKED',
	LINKED = 'LINKED',
	ALL = 'ALL',
}

export enum ProjectsMappingMode {
	BULK = 'bulk',
	SINGLE = 'single',
}

export enum ProjectsMappingOperations {
	UNLINK = 'UNMAP_PROJECTS',
	LINK = 'MAP_PROJECTS',
}

export type StatusTextMap = {
	[key in Partial<JiraProjectsHelpCenterMappingStatus>]?: string;
};
